/**
     * @desc //16查询订单状态和已开盲盒对应的NFT列表
调合约开盲盒之后调用
     */

import * as defs from '../../baseClass';
import { PontCore } from '../../pontCore';
import * as ajax from '../../../utils/request';

export class Params {}

export const init = new defs.Result();

export function request(params, body, options = {}) {
  return ajax.post('/box/getOrderStatusAndOpenedNftList', params);
}

export function upload(params, body, options = {}) {
  return ajax.upload('/box/getOrderStatusAndOpenedNftList', params);
}
